import React, { useCallback } from 'react'
import { Stack, TableCell, TableRow, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import EnhancedTableCell from '../../EnhancedTableCell'
import RenderChannelIcon from '../ChannelIcon'
import classes from '../style.module.scss'
import { useSelector } from '../../../../../store/store'
import { hasPermission } from '../../../../../utils/tools'
import { isEndCustomer } from '../../../../../constants'

const DashboardOrdersRow = ({ row }) => {
  const navigate = useNavigate()

  const { id, displayId, customer, jobName, place, channel } = row
  const { permissions, userInfo } = useSelector((state) => state.user)
  const permission = hasPermission(permissions?.orderDetailsFields)
  const { role } = userInfo

  const handleClick = useCallback(() => {
    navigate(`/orders/${id}`)
  }, [id, navigate])

  const TableCellOrder = (
    props: JSX.IntrinsicAttributes & {
      children: React.ReactNode
      action?: boolean | undefined
      checkbox?: boolean | undefined
      handleClick?: (() => void) | undefined
    }
  ) => {
    return (
      <EnhancedTableCell id={id} handleClick={handleClick} {...props}>
        {props.children}
      </EnhancedTableCell>
    )
  }

  return (
    <TableRow hover key={id}>
      <TableCellOrder>
        <Typography color="#1F0E72">{displayId || 'N/A'}</Typography>
      </TableCellOrder>
      {permission('customer') && !isEndCustomer(role) && (
        <>
          <TableCellOrder>
            <div className={classes.nameAndLogo}>
              <div className={classes.textContent}>
                <Typography>{customer.name}</Typography>
              </div>
            </div>
          </TableCellOrder>
        </>
      )}
      {permission('jobName') && (
        <TableCellOrder>
          <div className={classes.jobType}>
            <Typography>{jobName}</Typography>
          </div>
        </TableCellOrder>
      )}

      {permission('place') && <TableCellOrder>{place}</TableCellOrder>}
      {permission('channel') && (
        <TableCell width={channel.length * 37}>
          <Stack spacing={0.5} direction="row" alignItems="center">
            {channel.map((channelItem) => (
              <Stack
                key={channelItem}
                alignItems="center"
                justifyContent="center"
                borderRadius={9}
                sx={{
                  background: '#220D77',
                  width: { xs: 25, sm: 30, md: 35 },
                  height: { xs: 25, sm: 30, md: 35 },
                }}
              >
                <RenderChannelIcon channel={channelItem} size={window.innerWidth < 600 ? 13 : 20} />
              </Stack>
            ))}
          </Stack>
        </TableCell>
      )}
    </TableRow>
  )
}

export default DashboardOrdersRow
